import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type AuthorizedSignerReducedFragment = { __typename?: 'AuthorizedSigner', id: string, name: string };

export const AuthorizedSignerReducedFragmentDoc = gql`
    fragment AuthorizedSignerReduced on AuthorizedSigner {
  id
  name
}
    `;